<template>
  <div class="history-column">
    <div class="history-header">
      <div class="call-info">
        <user-portrate :target="callTarget" :displaySize="'mini'"/>
        <span class="target-name">{{ callTarget.name }}</span>
        <span class="send" v-if="!isReceive"><img src="/images/right_arrow.svg" class="send-allow-image"/></span>
        <span class="receive" v-if="isReceive"><img src="/images/left_arrow.svg" class="receive-allow-image"/></span>
        <span class="action-name" :class="{ notice: isNotify }">{{ actionName }}</span>
      </div>
      <div class="call-time">
        <div class="call-at-hero">{{ callAtHeroString }}</div>
        <div class="call-at-description">{{ callAtString }}</div>
      </div>
    </div>
    <div class="history-body">
      <div class="attendee-column"
        v-for="(attendee, index) in callAttendees"
        :key="'hisca' + attendee.id"
        :class="{ last: index + 1 == callAttendees.length}"
        @click="showAttendeeDesciption(attendee)"
        >
        <div class="attendee-info">
          <div class="attendee-name">
            <user-portrate :target="attendee" :displaySize="'small'"/>
            {{ attendee.name }}
            <img 
              src="/images/caller_icon.svg" 
              class="caller-marker-icon" 
              v-if="history.owner == attendee.narrative_phone_id" />
          </div>
          <div class="attendee-description" v-html="attendeeDescriptionHTML(attendee)"></div>
        </div>
        <div class="callback-controll" v-if="index === 0">
          <img src="/images/prepare_call_icon.svg" @click.stop.prevent="phoneCallBack" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// call history DIFINITIONS
// id: self.id,
// owner: self.owner_narrative_phone_id,
// owner_device_id: self.owner_device_id,
// owner_name: self.owner.name,
// owner_account_name: self.owner.account_name,
// owner_description: self.owner.description,
// zoom_meeting_id: self.zoom_meeting_id,
// zoom_meeting_password: self.zoom_meeting_password,
// callback_url: self.callback_url,
// triggered_at: self.triggered_at,
// call_end_at: self.call_end_at,
// state: self.state,
// attendees: [
    // id: self.id,
    // narrative_phone_id: self.narrative_phone_id,
    // device_id: self.device_id,
    // attendee_name: self.user.name,
    // attendee_account_name: self.user.account_name,
    // attendee_description: self.user.description,
    // joined: joined,
    // respound_at: self.respound_at,
    // hang_uped_at: self.hang_uped_at,
    // reject: self.reject,
    // reject_message: self.reject_message,
    // call_result: self.call_result
// ]
import { format, intlFormatDistance } from 'date-fns'

import UserPortrate from '@/components/appView/common/UserPortrate.vue'

export default {
  name: 'HistoryColumn',

  components: {
    UserPortrate
  },

  props: {
    history: Object,
    currentUser: Object,
    availableUsers: Object,
    displayState: String,
  },

  emits: [
    'phoneCallBackEvent',
    'showAttendeeDesciptionEvent',
  ],

  computed: {
    isReceive () {
      let receive = true
      this.availableUsers.forEach(user => {
        if (user.narrative_phone_id === this.history.owner) {
          receive = false
        }
      })
      return receive
    },

    targetAttendee () {
      if (this.isReceive) {
        let returnAttendee = null
        for(const attendee of this.history.attendees) {
          for(const user of this.availableUsers) {
            if (user.narrative_phone_id === attendee.narrative_phone_id) {
              if (this.displayState == 'missed') {
                if (!attendee.joined) {
                  returnAttendee = attendee
                }
              } else {
                returnAttendee = attendee
              }
            }
          }
        }
        return returnAttendee
      }
      return null
    },

    callTarget () {
      if (this.isReceive) {
        return {
          narrative_phone_id: this.targetAttendee.narrative_phone_id,
          name: this.targetAttendee.attendee_name,
          account_name: this.targetAttendee.attendee_account_name,
          description: this.targetAttendee.attendee_description,
          icon_img_path: this.targetAttendee.attendee_icon_img_path,
          theme_color: this.targetAttendee.attendee_theme_color,
          type: '通話参加者',
          call_state: this.targetAttendee.joined ? '通話参加' : '通話不参加',
          call_start: this.targetAttendee.joined ? new Date(this.history.attendees[0].respound_at) : new Date(this.history.triggered_at),
          call_end: this.targetAttendee.joined ? new Date(this.history.attendees[0].hang_uped_at) : null
        }
      } else {
        return {
          narrative_phone_id: this.history.owner,
          name: this.history.owner_name,
          account_name: this.history.owner_account_name,
          description: this.history.owner_description,
          icon_img_path: this.history.owner_icon_img_path,
          theme_color: this.history.owner_theme_color,
          type: '発信者',
          call_state: this.callStateJp,
          call_start: new Date(this.history.triggered_at),
          call_end: new Date(this.history.call_end_at)
        }
      }
    },

    actionName () {
      if (this.isReceive) {
        if (this.targetAttendee && this.targetAttendee.joined) {
          return '着信'
        } else {
          return '不在着信'
        }
      } else {
        return '発信'
      }
    },

    isNotify () {
      if (this.targetAttendee && !this.targetAttendee.joined) {
        return true
      }
      return false
    },

    callAtHeroString () {
      let callAt = new Date(this.history.triggered_at)
      if (callAt) {
        return intlFormatDistance(callAt, new Date(), { locale: 'ja' })
      }
      return '---'
    },

    callAtString () {
      let callAt = new Date(this.history.triggered_at)
      if (callAt) {
        return format(callAt, 'yyyy/MM/dd HH:mm:ss')
      }
      return '---'
    },

    callStateJp () {
      // PHONE_CALL_STATE_DEFAULT = 0
      // PHONE_CALL_STATE_CALLING = 1
      // PHONE_CALL_STATE_CONNECTED = 2
      // PHONE_CALL_STATE_FINISHED = 3
      // PHONE_CALL_STATE_FAILED = 4
      // PHONE_CALL_STATE_ABOAT = 5
      switch (this.history.state) {
        case 3:
          return '正常終了'
        case 4:
          return '通話失敗'
        case 5:
          return '通話取消'
        default:
          return '-----'
      }
    },

    topTarget () {
      if (this.isReceive) {
        return {
          narrative_phone_id: this.history.owner,
          name: this.history.owner_name,
          account_name: this.history.owner_account_name,
          description: this.history.owner_description,
          icon_img_path: this.history.owner_icon_img_path,
          theme_color: this.history.owner_theme_color,
          type: '発信者',
          call_state: this.callStateJp,
          call_start: new Date(this.history.triggered_at),
          call_end: new Date(this.history.call_end_at)
        }
      } else {
        return {
          narrative_phone_id: this.history.attendees[0].narrative_phone_id,
          name: this.history.attendees[0].attendee_name,
          account_name: this.history.attendees[0].attendee_account_name,
          description: this.history.attendees[0].attendee_description,
          icon_img_path: this.history.attendees[0].attendee_icon_img_path,
          theme_color: this.history.attendees[0].attendee_theme_color,
          type: '通話参加者',
          call_state: this.history.attendees[0].joined ? '通話参加' : '通話不参加',
          call_start: this.history.attendees[0].joined ? new Date(this.history.attendees[0].respound_at) : new Date(this.history.triggered_at),
          call_end: this.history.attendees[0].joined ? new Date(this.history.attendees[0].hang_uped_at) : null
        }
      }
    },

    callAttendees () {
      let filterdAttendees = []
      if (this.isReceive) {
        filterdAttendees = this.history.attendees.filter((att) => {
          if (this.callTarget.narrative_phone_id == att.narrative_phone_id) {
            return false
          }
          this.availableUsers.forEach(usr => {
            if (usr.narrative_phone_id == att.narrative_phone_id) {
              return false
            }
          })
          return true
        })
      } else {
        filterdAttendees = this.history.attendees
      }
      let formedAttendees = []
      if (this.isReceive) {
        formedAttendees.push({
          narrative_phone_id: this.history.owner,
          name: this.history.owner_name,
          account_name: this.history.owner_account_name,
          description: this.history.owner_description,
          icon_img_path: this.history.owner_icon_img_path,
          theme_color: this.history.owner_theme_color,
          type: '発信者',
          call_state: '通話発信',
          call_start: new Date(this.history.triggered_at),
          call_end: this.history.call_end_at
        })
      }
      for(const att of filterdAttendees) {
        formedAttendees.push(
          {
            narrative_phone_id: att.narrative_phone_id,
            name: att.attendee_name,
            account_name: att.attendee_account_name,
            description: att.attendee_description,
            icon_img_path: att.attendee_icon_img_path,
            theme_color: att.attendee_theme_color,
            type: '通話参加者',
            call_state: att.joined ? '通話参加' : '通話不参加',
            call_start: att.joined ? new Date(att.respound_at) : new Date(this.history.triggered_at),
            call_end: att.joined ? new Date(att.hang_uped_at) : null
          }
        )
      }
      return formedAttendees
    },

  },

  methods: {
    attendeeDescriptionHTML (attendee) {
      if (attendee.description) {
        return attendee.description.replace(/\n/gi, '<br />')
      }
      return ''
    },

    phoneCallBack () {
      this.$emit('phoneCallBackEvent', this.callTarget.account_name, this.callAttendees)
    },

    showAttendeeDesciption (attendee) {
      this.$emit('showAttendeeDesciptionEvent', this.callTarget, attendee)
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.history-column {
  border-bottom: 1px solid #aaa;
  padding: 5px 10px;
  .history-header {
    display: flex;
    justify-content: space-between;
    .call-info {
      max-width: calc(100% - 130px);
      display: flex;
      align-items: center;
      .target-name {
        // min-width: 50px;
        // max-width: calc(100% - 100px - 50px);
        margin-left: 10px;
        font-size: 13pt;
        font-weight: bold;
      }
      img {
        margin: 0 5px;
        height: 10pt;
      }
      .action-name {
        width: 4rem;
        font-size: 13pt;
        &.notice {
          width: 6rem;
          color: $danger-color;
        }
      }
    }
    .call-time {
      flex-basis: 130px;
      .call-at-hero {
        font-size: 21pt;
        font-weight: bold;
        text-align: right;
      }
      .call-at-description {
        font-size: 10pt;
        text-align: right;
      }
    }
  }
  .history-body {
    padding: 0 10px;
  }
  .attendee-column {
    padding: 10px;
    border-bottom: 1px solid #aaa;
    display: flex;
    justify-content: space-between;
    &.last {
      border-bottom: none;
    }
    .attendee-info {
      .attendee-name {
        font-size: 21px;
        img {
          width: 18px;
        }
      }
      .attendee-description {
        font-size: 11pt;
      }
    }
    .callback-controll {
      img {
        height: 60px;
        width: 60px;
      }
    }
  }
}
</style>